import '../bracket/bracket.css'
import { mountAll } from '../bracket/index.js'
import { mountPlacementEditor } from '../bracket/editor.js'

function boot() {
  document.querySelectorAll('[data-js-placement-editor]').forEach(mountPlacementEditor)
  mountAll()
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
else boot()
